// extracted by mini-css-extract-plugin
module.exports = {"areaZoomInput":"AreaZoomPropertyForm_areaZoomInput__2WdRJ","areaButton":"AreaZoomPropertyForm_areaButton__5jSZ_"};